




























import { i18n } from "@/resources/locales";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "close-webinar-component",
})
export default class CloseWebinarComponent extends Vue {
  get active(): boolean {
    return this.$store.getters["SystemStore/getShowCloseWebinarModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setShowCloseWebinarModalAction", {
      close: e,
      id: 0,
    });
  }
  async confirm() {
    const id = this.$store.getters["SystemStore/getWebinarCloseId"];
    await this.$store.dispatch("MeetingStore/setWebinarActiveAction", false);
    await this.$store.dispatch("MeetingStore/closeWebinarAction", {
      roomId: id,
      callback: async (response) => {
        await this.$store.dispatch(
          "SystemStore/setShowCloseWebinarModalAction",
          {
            close: false,
            id: 0,
          }
        );
      },
      callbackError: async (error) => {
        await this.$store.dispatch(
          "SystemStore/setShowCloseWebinarModalAction",
          {
            close: false,
            id: 0,
          }
        );
        console.log("error closeWebinarAction ", error);
      },
    });
  }
}
